/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScanStatus = {
  properties: {
    id: {
      type: 'string',
      description: `UUID of the scan`,
      isRequired: true,
    },
    status: {
      type: 'Enum',
      isRequired: true,
    },
    downloadUrl: {
      type: 'string',
      description: `Will be null if the virus file is not in a successful state. Once the file has been successfully scanned,
            a presigned S3 URL to download the original scan file will be available.
            `,
      isNullable: true,
    },
  },
} as const;
